import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'App';
import { createClassroom } from 'api/classroomApi';
import Flex from 'components/common/Flex';
import { useUser } from 'context/UserContext';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const CreateClassroom = () => {
  const navigate = useNavigate();
  const [classroomName, setClassroomName] = useState('');

  const user = useUser();
  useEffect(() => {
    if (user?.classroomCode) {
      navigate('/classe');
    }
  }, []);

  const handleFieldChange = e => {
    setClassroomName(e.target.value);
  };

  const mutation = useMutation({
    mutationFn: createClassroom,
    onSuccess: async data => {
      await queryClient.invalidateQueries({ queryKey: ['userData'] });
      toast.success(() => (
        <span>
          Hai creato la classe
          <br />
          <strong>{data.name}</strong>!
        </span>
      ));
      navigate('/guide/start');
      return;
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    }
  });

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    mutation.mutate({ classroomName });
  };

  return (
    <>
      <Card className="mb-3">
        <Card.Body>
          <div>
            <h3 className="fw-light fs-4 mb-0 text-primary text-center">
              <strong>Crea la tua classe</strong>
            </h3>
            <h5 className="fw-light mt-3 text-center">
              <strong>Aggiungi la tua classe</strong> su FantaClasse e{' '}
              <strong>invita i tuoi compagni!</strong>
            </h5>
          </div>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body className="p-0">
          <Row className="g-0 flex-center">
            <Col md={7} as={Flex} alignItems="center" justifyContent="center">
              <div className="p-4 p-md-5 flex-grow-1">
                <Form className="mt-3" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nome della classe</Form.Label>
                    <Form.Control
                      placeholder="La fantastica 4E"
                      value={classroomName}
                      name="classroomName"
                      onChange={handleFieldChange}
                      type="text"
                      minLength={2}
                      maxLength={30}
                      autocomplete="on"
                      required
                    />
                  </Form.Group>

                  <div className="mb-3">
                    <Button
                      type="submit"
                      className="w-100"
                      disabled={
                        !classroomName ||
                        classroomName.length < 2 ||
                        classroomName.length > 30
                      }
                    >
                      Crea classe
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default CreateClassroom;
